// src/settings.js
// Use environment variable for API base URL, fallback to localhost dev default
export const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
export const VA_LOGOUT_URL = process.env.VA_LOGOUT_URL || "https://login.barracudanetworks.com/auth/logout";
